module.exports = __webpack_public_path__ + "img/luke.fe336b0c.jpeg";